import React, { useState, useEffect } from "react";
import "./IncompleteAdmission.css";
import "./AdmissionFeeCard.css";
import { API_BASE_URL } from "./config";
import { useLoading } from "./LoadingContext";
import OTPModal from "./OTPModal";
import { flushSync } from "react-dom";
import PaymentSuccessScreen from "./PaymentSuccessScreen";


const IncompleteAdmission = ({ onClose, setShowIncompleteAdmission }) => {
  const [email, setEmail] = useState("");
  const [newAdmissionStatus, setNewAdmissionStatus] = useState(null);
  const [resumeAdmissionSession, setResumeAdmissionSession] = useState("");
  const [resumeAdmissionOrder, setResumeAdmissionOrder] = useState(null);
  const [newAdmissionReferral, setNewAdmissionReferral] = useState("");
  const [newAdmissionReferralValid, setNewAdmissionReferralValid] = useState(false);
  const [newAdmissionBusy, setNewAdmissionBusy] = useState(false);
  const newCheckoutEnabled = process.env.REACT_APP_ADMISSION_CHECKOUT_ENABLED !== "false";


  const [showscreen_1, setshowscreen_1] = useState(true);
  const [showscreen_2, setshowscreen_2] = useState(false);
  const [showscreen_3, setshowscreen_3] = useState(false);
  const [showscreen_4, setshowscreen_4] = useState(false);
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const { showLoading, hideLoading } = useLoading();

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [BothPaymentshowOtpModal, setBothPaymentshowOtpModal] =
    useState(false);




  const [showInstallmentSchedule, setShowInstallmentSchedule] = useState(false);

  const [extraletters, setextraletters] = useState("");
  const [StudentID, setStudentID] = useState("");
  const [PayOutHeading, setPayOutHeading] = useState("");

  const [PaymentOrderGenerated, setPaymentOrderGenerated] = useState(false);

  const [BothScreenNextScreen, setBothScreenNextScreen] = useState(false);


  const [fee, setFee] = useState(350);
  const [paymentConfig, setPaymentConfig] = useState(null);

  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponData, setCouponData] = useState(null);
  const [showCouponSuccessModal, setShowCouponSuccessModal] = useState(false);
  const [couponApplying, setCouponApplying] = useState(false);

  const [selectedInstallmentNumbers, setSelectedInstallmentNumbers] = useState([]);

  const gstPercent = Number(paymentConfig?.gst_percent || 18);

  const registrationFee = Number(paymentConfig?.registration_fee || 350);
  const gstAmount = (fee * gstPercent) / 100;
  const totalAmount = fee + gstAmount;

  const ONE_TIME_PAYMENT = Number(paymentConfig?.training_one_time_fee || 54000);

  const installmentSchedule = (paymentConfig?.installment_schedule || [
    { installment_number: 1, amount: 10000 },
    { installment_number: 2, amount: 10000 },
    { installment_number: 3, amount: 10000 },
    { installment_number: 4, amount: 10000 },
    { installment_number: 5, amount: 10000 },
    { installment_number: 6, amount: 10000 },
    { installment_number: 7, amount: 4100 },
  ]).map((item) => ({
    installment_number: Number(item.installment_number),
    month_number: Number(item.installment_number),
    day_min: (Number(item.installment_number) - 1) * 30 + 1,
    day_max: Number(item.installment_number) * 30,
    amount_inr: Number(item.amount),
  }));

  const INSTALLMENT_FIRST_PAYMENT = Number(
    installmentSchedule?.[0]?.amount_inr || 10000
  );

  const gstAmountTotal = Math.round((ONE_TIME_PAYMENT * gstPercent) / 100);
  const totalPayable = ONE_TIME_PAYMENT + gstAmountTotal;

  const installmentGstAmount = Math.round(
    (INSTALLMENT_FIRST_PAYMENT * gstPercent) / 100
  );

  const installmentTotalPayable =
    INSTALLMENT_FIRST_PAYMENT + installmentGstAmount;

  const installmentTotalFee = installmentSchedule.reduce(
    (sum, item) => sum + item.amount_inr,
    0
  );
  const couponDiscountAmount = Number(
    couponData?.student_discount_amount || 0
  );

  const discountedOneTimeBase = couponApplied
    ? Math.max(ONE_TIME_PAYMENT - couponDiscountAmount, 0)
    : ONE_TIME_PAYMENT;

  const discountedOneTimeGst = Math.round(
    (discountedOneTimeBase * gstPercent) / 100
  );

  const discountedOneTimeTotal =
    discountedOneTimeBase + discountedOneTimeGst;

  const discountedInstallmentTotalFee = couponApplied
    ? Math.max(installmentTotalFee - couponDiscountAmount, 0)
    : installmentTotalFee;

  const discountedInstallmentTotalGst = Math.round(
    (discountedInstallmentTotalFee * gstPercent) / 100
  );

  const discountedInstallmentGrandTotal =
    discountedInstallmentTotalFee + discountedInstallmentTotalGst;



  // eslint-disable-next-line
  const [counsellingChecked, setCounsellingChecked] = useState(false);
  // eslint-disable-next-line
  const [counsellingPaid, setCounsellingPaid] = useState(false);
  // eslint-disable-next-line
  const [counsellingData, setCounsellingData] = useState(null);
  const [showIncompleteCounselling, setShowIncompleteCounselling] = useState(false);

  const [counsellingCalendarDays, setCounsellingCalendarDays] = useState([]);
  const [counsellingSlotsLoading, setCounsellingSlotsLoading] = useState(false);
  const [counsellingSelectedDate, setCounsellingSelectedDate] = useState("");
  const [counsellingSelectedSlot, setCounsellingSelectedSlot] = useState(null);

  const [counsellingGoal, setCounsellingGoal] = useState("");
  const [counsellingPaymentStarted, setCounsellingPaymentStarted] = useState(false);



  const handleApplyCoupon = async () => {
    const cleanCouponCode = couponCode.trim().toUpperCase();

    if (!cleanCouponCode) {
      alert("Please enter coupon code.");
      return;
    }

    try {
      setCouponApplying(true);
      showLoading("Checking coupon...");

      const response = await fetch(`${API_BASE_URL}/coupon/validate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          coupon_code: cleanCouponCode,
          plan_type: "ONE_TIME",
        }),
      });

      const data = await response.json();

      if (!response.ok || data.valid !== true) {
        setCouponApplied(false);
        setCouponData(null);
        alert(data.message || data.detail || "Invalid coupon code.");
        return;
      }

      setCouponApplied(true);
      setCouponData(data);
      setCouponCode(cleanCouponCode);
      setShowCouponSuccessModal(true);
    } catch (error) {
      console.error("Coupon apply error:", error);
      alert("Unable to apply coupon. Please try again.");
    } finally {
      await sleep(500);
      hideLoading();
      setCouponApplying(false);
    }
  };




  useEffect(() => {
    const fetchPaymentConfig = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/payment-config`);
        const data = await response.json();

        if (response.ok && data.status === "success") {
          setPaymentConfig(data);
          setFee(Number(data.registration_fee || 350));
        }
      } catch (error) {
        console.error("Payment config loading error:", error);
      }
    };

    fetchPaymentConfig();
  }, []);


  const getGstAmount = (amount) => Math.round((amount * gstPercent) / 100);
  const getTotalWithGst = (amount) => amount + getGstAmount(amount);

  const installmentBaseTotal = installmentSchedule.reduce(
    (sum, item) => sum + item.amount_inr,
    0
  );

  const installmentGstTotal = installmentSchedule.reduce(
    (sum, item) => sum + getGstAmount(item.amount_inr),
    0
  );

  const installmentGrandTotal = installmentBaseTotal + installmentGstTotal;





  // const installmentGrandTotal = installmentBaseTotal + installmentGstTotal;
  const installmentExtraFee = installmentBaseTotal - ONE_TIME_PAYMENT;
  // const remainingAfterFirstInstallment =
  //   installmentBaseTotal - INSTALLMENT_FIRST_PAYMENT;

  const [showSuccessScreen, setShowSuccessScreen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    window.__ALLOW_PAYMENT_SUCCESS_REDIRECT = false;

    return () => {
      if (!window.__ALLOW_PAYMENT_SUCCESS_REDIRECT) {
        window.__ALLOW_PAYMENT_SUCCESS_REDIRECT = false;
      }
    };
  }, []);

  useEffect(() => {
    if (showSuccessScreen || window.__ALLOW_PAYMENT_SUCCESS_REDIRECT) {
      return;
    }

    const handleNavigation = (event) => {
      if (window.__ALLOW_PAYMENT_SUCCESS_REDIRECT) {
        return;
      }

      const confirmation = window.confirm(
        "⚠️ Are you sure you want to leave? Your payment process may be interrupted."
      );

      if (!confirmation) {
        event.preventDefault();
        window.history.pushState(null, "", window.location.href);
      }
    };

    const handleRefresh = (event) => {
      if (window.__ALLOW_PAYMENT_SUCCESS_REDIRECT) {
        return;
      }

      const confirmation = window.confirm(
        "⚠️ Are you sure you want to refresh? Your payment progress will be lost."
      );

      if (!confirmation) {
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleNavigation);
    window.addEventListener("beforeunload", handleRefresh);

    return () => {
      window.removeEventListener("popstate", handleNavigation);
      window.removeEventListener("beforeunload", handleRefresh);
    };
  }, [showSuccessScreen]);

  const generateRandomCode = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = "";

    for (let i = 0; i < 4; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }

    return result;
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value.trim().toLowerCase());
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const checkNewAdmissionPaymentAfterOtp = async (sessionToken) => {
    if (!StudentID || !sessionToken) {
      alert("Please verify your email OTP again.");
      return;
    }

    showLoading("Checking your admission payment status...");

    try {
      const response = await fetch(
        `${API_BASE_URL}/admission/payment-status`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            student_id: StudentID,
            admission_session_token: sessionToken,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.detail || "Unable to check admission payment.");
        return;
      }

      if (data.status === "LEGACY_ADMISSION") {
        setNewAdmissionStatus(null);
        setResumeAdmissionSession("");
        setResumeAdmissionOrder(null);
        await checkCounsellingStatusAfterIncompleteOtp();
        return;
      }

      setResumeAdmissionSession(sessionToken);

      if (
        data.status === "RESUMABLE" &&
        data.order_id &&
        data.key_id &&
        Number.isInteger(Number(data.amount)) &&
        Number(data.amount) > 0 &&
        data.currency === "INR"
      ) {
        setResumeAdmissionOrder({
          order_id: data.order_id,
          key_id: data.key_id,
          amount: Number(data.amount),
          currency: data.currency,
        });
      } else {
        setResumeAdmissionOrder(null);
      }

      setNewAdmissionStatus({
        status: data.status,
        message: data.message || "",
      });

      setshowscreen_1(false);
      setshowscreen_2(false);
      setshowscreen_3(false);
      setshowscreen_4(false);
      setShowIncompleteCounselling(false);

    } catch (error) {
      console.error("Admission status request failed.");
      alert("Unable to check admission payment. Please try again.");
    } finally {
      hideLoading();
    }
  };


  const handleResumeAdmissionPayment = async () => {
    if (!StudentID || !resumeAdmissionSession || !resumeAdmissionOrder) {
      alert("Please verify your email again.");
      return;
    }

    showLoading("Rechecking your original payment order...");

    try {
      const response = await fetch(
        `${API_BASE_URL}/admission/payment-status`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            student_id: StudentID,
            admission_session_token: resumeAdmissionSession,
          }),
        }
      );

      const data = await response.json();

      if (
        !response.ok ||
        data.status !== "RESUMABLE" ||
        data.order_id !== resumeAdmissionOrder.order_id ||
        data.key_id !== resumeAdmissionOrder.key_id ||
        Number(data.amount) !== resumeAdmissionOrder.amount ||
        data.currency !== "INR"
      ) {
        setResumeAdmissionOrder(null);
        setNewAdmissionStatus({
          status: "REVIEW_REQUIRED",
          message: "Payment status changed. Please contact admissions support.",
        });
        return;
      }

      if (!newCheckoutEnabled) {
        alert("Original order verified. Payment checkout is disabled pending testing.");
        return;
      }
      launchNewAdmissionCheckout(data);
    } catch (error) {
      alert("Unable to verify your payment order. Please try again.");
    } finally {
      hideLoading();
    }
  };

  const launchNewAdmissionCheckout = (order) => {
    if (!newCheckoutEnabled || !window.Razorpay) {
      alert("Secure checkout is not available yet.");
      return;
    }
    if (!order || order.currency !== "INR" ||
        ![3250000, 2750000].includes(Number(order.amount)) ||
        !order.order_id || !order.key_id) {
      alert("Invalid payment details. Please contact admissions support.");
      return;
    }
    const rzp = new window.Razorpay({
      key: order.key_id,
      order_id: order.order_id,
      amount: Number(order.amount),
      currency: "INR",
      name: "StudyAIPlacement",
      description: "Programme Admission Fee (GST included)",
      handler: async (payment) => {
        setNewAdmissionBusy(true);
        try {
          const resp = await fetch(`${API_BASE_URL}/payment/verify`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              razorpay_order_id: payment.razorpay_order_id,
              razorpay_payment_id: payment.razorpay_payment_id,
              razorpay_signature: payment.razorpay_signature,
            }),
          });
          const result = await resp.json();
          if (!resp.ok || result.status !== "success") {
            setNewAdmissionStatus({status:"REVIEW_REQUIRED",message:"Payment verification needs review. Do not pay again."});
            setResumeAdmissionOrder(null);
            return;
          }
          setResumeAdmissionOrder(null);
          setNewAdmissionStatus({status:"PAID",message:"Admission payment verified."});
        } catch (_) {
          setNewAdmissionStatus({status:"REVIEW_REQUIRED",message:"Payment status uncertain. Do not pay again."});
          setResumeAdmissionOrder(null);
        } finally {
          setNewAdmissionBusy(false);
        }
      },
      modal: {ondismiss: () => {
        // Checkout dismissal is not payment failure; refresh status before retry.
        refreshNewAdmissionStatus();
      }},
    });
    rzp.open();
  };

  const refreshNewAdmissionStatus = async () => {
    if (!StudentID || !resumeAdmissionSession) return;
    await checkNewAdmissionPaymentAfterOtp(resumeAdmissionSession);
  };

  const validateNewAdmissionReferral = async () => {
    const code = newAdmissionReferral.trim().toUpperCase();
    if (!code) {setNewAdmissionReferralValid(false);return;}
    setNewAdmissionBusy(true);
    try {
      const res = await fetch(`${API_BASE_URL}/admission/referral/validate`, {
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({referral_code:code}),
      });
      const result = await res.json();
      if (!res.ok || Number(result.total_payable) !== 27500 || Number(result.discount) !== 5000) {
        throw new Error("Referral code is not valid.");
      }
      setNewAdmissionReferral(code);
      setNewAdmissionReferralValid(true);
    } catch (_) {
      setNewAdmissionReferralValid(false);
      setNewAdmissionReferral("");
      alert(
        "This referral code is invalid. It has been removed, and you can continue with the standard fee of ₹32,500."
      );
    } finally {setNewAdmissionBusy(false);}
  };

  const startNewAdmissionPayment = async () => {
    if (newAdmissionBusy) return;

    if (!newCheckoutEnabled) {
      alert("Secure admission checkout is temporarily unavailable.");
      return;
    }

    if (!StudentID || !resumeAdmissionSession) {
      alert("Your secure admission session has expired. Please verify your email again.");
      return;
    }

    if (newAdmissionStatus?.status !== "NO_RESERVATION") {
      alert("Your payment status has changed. We are refreshing it now.");
      await refreshNewAdmissionStatus();
      return;
    }
    if (newAdmissionReferral.trim() && !newAdmissionReferralValid) {
      alert("Validate or clear the referral code before paying.");return;
    }
    setNewAdmissionBusy(true);
    try {
      // Recheck BEFORE creating the order, but do not trust the browser for idempotency.
      const statusResp = await fetch(`${API_BASE_URL}/admission/payment-status`, {
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({student_id:StudentID,admission_session_token:resumeAdmissionSession}),
      });
      const statusData = await statusResp.json();
      if (!statusResp.ok || statusData.status !== "NO_RESERVATION") {
        alert(
          statusData.detail ||
            statusData.message ||
            "Unable to start payment because your admission status changed."
        );
        await refreshNewAdmissionStatus();
        return;
      }
      const orderResp = await fetch(`${API_BASE_URL}/payment/create-order`, {
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          student_id:StudentID,payment_context:"NEW_ADMISSION",
          admission_session_token:resumeAdmissionSession,
          ...(newAdmissionReferralValid ? {coupon_code:newAdmissionReferral} : {}),
        }),
      });
      const order = await orderResp.json();
      if (!orderResp.ok || !order.order_id) {
        await refreshNewAdmissionStatus();
        alert(order.detail || "Payment status needs review before retrying.");
        return;
      }
      const expected = newAdmissionReferralValid ? 2750000 : 3250000;
      if (Math.round(Number(order.total_amount)*100) !== expected) {
        setNewAdmissionStatus({status:"REVIEW_REQUIRED",message:"Unexpected order amount; contact support."});
        return;
      }
      launchNewAdmissionCheckout({...order,amount:expected});
    } catch (_) {
      await refreshNewAdmissionStatus();
      alert("Please review your payment status before trying again.");
    } finally {setNewAdmissionBusy(false);}
  };

  const checkCounsellingStatusAfterIncompleteOtp = async () => {
    if (!email) {
      alert("Email not found. Please try again.");
      return;
    }

    showLoading("🔍 Checking your counselling status...");

    try {
      const response = await fetch(`${API_BASE_URL}/counselling/check-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
        }),
      });

      const data = await response.json();

      console.log("Incomplete counselling status response:", data);

      if (!response.ok) {
        alert(data.detail || "Unable to check counselling status.");
        return;
      }

      setCounsellingChecked(true);
      setCounsellingPaid(Boolean(data.counselling_paid));
      setCounsellingData(data);

      if (data.counselling_paid) {
        // Counselling already paid, directly show program fee options
        setShowIncompleteCounselling(false);

        setshowscreen_1(false);
        setshowscreen_2(true);
        setshowscreen_3(false);
        setshowscreen_4(false);

        setFee(registrationFee);
        setPaymentOrderGenerated(false);

        setTimeout(() => {
          window.scrollTo({
            top: 300,
            behavior: "smooth",
          });
        }, 300);
      } else {
        // Counselling not paid, show counselling slot modal
        setShowIncompleteCounselling(true);

        setshowscreen_1(false);
        setshowscreen_2(false);
        setshowscreen_3(false);
        setshowscreen_4(false);

        setFee(registrationFee);
        setPaymentOrderGenerated(false);
      }
    } catch (error) {
      console.error("Incomplete counselling status check error:", error);
      alert("Something went wrong while checking counselling status.");
    } finally {
      await sleep(700);
      hideLoading();
    }
  };

  const fetchCounsellingSlotsForIncompleteAdmission = async () => {
    try {
      setCounsellingSlotsLoading(true);

      const response = await fetch(
        `${API_BASE_URL}/counselling/available-slots?days=90`
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.detail || "Unable to load counselling slots.");
        return;
      }

      if (data.status === "success") {
        console.log("Incomplete raw counselling slots:", data);

        const rawCalendar = data.calendar || [];

        const normalizedCalendar = rawCalendar.map((day) => {
          const slots = day.slots || [];

          const normalizedSlots = slots.map((slot) => {
            const isAvailable =
              slot.available === true ||
              slot.is_available === true ||
              slot.status === "available" ||
              slot.status === "AVAILABLE" ||
              slot.booking_status === "AVAILABLE" ||
              slot.booked === false;

            return {
              ...slot,
              time: slot.time || slot.slot_time || slot.label || "",
              available: isAvailable,
            };
          });

          const availableCount = normalizedSlots.filter((slot) => slot.available).length;

          return {
            ...day,
            dateKey: day.dateKey || day.date_key || day.date || "",
            dayName: day.dayName || day.day_name || day.weekday || "",
            displayDate: day.displayDate || day.display_date || day.date || "",
            available_count:
              day.available_count ??
              day.availableCount ??
              day.available_slots ??
              day.availableSlots ??
              availableCount,
            slots: normalizedSlots,
          };
        });

        console.log("Incomplete normalized counselling slots:", normalizedCalendar);

        setCounsellingCalendarDays(normalizedCalendar);

        if (normalizedCalendar.length > 0) {
          setCounsellingSelectedDate(normalizedCalendar[0].dateKey);
        }
      }
    } catch (error) {
      console.error("Incomplete counselling slot loading error:", error);
      alert("Unable to load counselling slots.");
    } finally {
      setCounsellingSlotsLoading(false);
    }
  };

  useEffect(() => {
    if (showIncompleteCounselling) {
      fetchCounsellingSlotsForIncompleteAdmission();
    }
    // eslint-disable-next-line
  }, [showIncompleteCounselling]);

  const activeCounsellingDay = React.useMemo(() => {
    return (
      counsellingCalendarDays.find(
        (day) => day.dateKey === counsellingSelectedDate
      ) || counsellingCalendarDays[0]
    );
  }, [counsellingCalendarDays, counsellingSelectedDate]);


  const handleIncompleteCounsellingPayment = async () => {
    if (!counsellingSelectedSlot) {
      alert("Please select counselling slot first.");
      return;
    }

    try {
      setCounsellingPaymentStarted(true);
      showLoading("Preparing your counselling payment...");

      const startResponse = await fetch(
        `${API_BASE_URL}/counselling/start-from-incomplete-admission`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email.trim().toLowerCase(),
            student_id: StudentID,
            goal: counsellingGoal.trim(),
            counselling_date: counsellingSelectedDate,
            slot_time: counsellingSelectedSlot.time,
          }),
        }
      );

      const startData = await startResponse.json();

      if (!startResponse.ok) {
        alert(startData.detail || "Unable to start counselling booking.");
        await fetchCounsellingSlotsForIncompleteAdmission();
        return;
      }

      if (startData.already_paid) {
        setCounsellingPaid(true);
        setCounsellingData(startData);
        setShowIncompleteCounselling(false);

        setshowscreen_1(false);
        setshowscreen_2(true);
        setshowscreen_3(false);
        setshowscreen_4(false);

        setCounsellingPaymentStarted(false);

        await sleep(700);
        hideLoading();
        return;
      }

      const bookingId = startData.booking_id;

      const orderResponse = await fetch(
        `${API_BASE_URL}/counselling/create-payment-order`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            booking_id: bookingId,
          }),
        }
      );

      const orderData = await orderResponse.json();

      if (!orderResponse.ok) {
        alert(orderData.detail || "Unable to create counselling payment order.");
        await fetchCounsellingSlotsForIncompleteAdmission();
        return;
      }

      await sleep(700);
      hideLoading();

      const options = {
        key: orderData.key_id,
        amount: orderData.total_amount * 100,
        currency: "INR",
        name: "StudyAIPlacement Counselling",
        description: "Personal Career Counselling Fee",
        order_id: orderData.order_id,

        handler: async function (response) {
          try {
            showLoading(
              "Verifying counselling payment and confirming your slot..."
            );

            const verifyResponse = await fetch(
              `${API_BASE_URL}/counselling/verify-payment`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  booking_id: bookingId,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_signature: response.razorpay_signature,
                }),
              }
            );

            const verifyData = await verifyResponse.json();

            if (!verifyResponse.ok) {
              alert(
                verifyData.detail || "Counselling payment verification failed."
              );
              await fetchCounsellingSlotsForIncompleteAdmission();
              return;
            }

            setCounsellingPaid(true);
            setCounsellingData(verifyData);
            setShowIncompleteCounselling(false);

            setshowscreen_1(false);
            setshowscreen_2(true);
            setshowscreen_3(false);
            setshowscreen_4(false);

            setCounsellingPaymentStarted(false);

            await fetchCounsellingSlotsForIncompleteAdmission();
            await sleep(700);
            hideLoading();

            window.scrollTo({
              top: 300,
              behavior: "smooth",
            });
          } catch (error) {
            console.error("Incomplete counselling verify error:", error);
            alert("Counselling payment verification failed.");
            setCounsellingPaymentStarted(false);
            hideLoading();
          } finally {
            hideLoading();
            document.body.classList.remove("razorpay-active");
          }
        },

        modal: {
          escape: false,
          backdropclose: false,
          ondismiss: function () {
            setCounsellingPaymentStarted(false);
            document.body.classList.remove("razorpay-active");
            alert(
              "Counselling payment was not completed. Please complete it to continue admission."
            );
          },
        },

        theme: {
          color: "#3399cc",
        },
      };

      const rzp = new window.Razorpay(options);
      document.body.classList.add("razorpay-active");
      rzp.open();
    } catch (error) {
      console.error("Incomplete counselling payment error:", error);
      alert("Something went wrong while starting counselling payment.");
      setCounsellingPaymentStarted(false);
    } finally {
      await sleep(700);
      hideLoading();
    }
  };

  const prepareTrainingPayment = async (planType) => {
    if (!StudentID) {
      alert("Student ID missing. Please verify email again.");
      return;
    }

    try {
      showLoading("Preparing your payment plan...");

      const response = await fetch(`${API_BASE_URL}/payment/build-snapshot`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          student_id: StudentID,
          plan_type: planType,
          coupon_code: couponCode.trim() ? couponCode.trim().toUpperCase() : null,
        }),
      });

      const data = await response.json();

      if (!response.ok || data.status !== "success") {
        alert(data.detail || "Unable to prepare payment plan.");
        return;
      }

      const snapshot = data.payment_plan_snapshot;

      if (planType === "ONE_TIME") {
        setFee(Number(snapshot.final_one_time_payable || 0));
        setPayOutHeading("One Time Payment");


        setSelectedInstallmentNumbers([]);
      }

      if (planType === "INSTALLMENT") {
        const firstInstallment = snapshot.final_installment_schedule.find(
          (item) => Number(item.installment_number) === 1
        );

        setFee(Number(firstInstallment?.final_amount || 0));
        setPayOutHeading("Installment Payment");

        setSelectedInstallmentNumbers([1]);
      }

      setshowscreen_2(false);
      setshowscreen_3(true);
      setBothScreenNextScreen(false);

      window.scrollTo({
        top: 300,
        behavior: "smooth",
      });
    } catch (error) {
      console.error("Prepare training payment error:", error);
      alert("Unable to prepare payment plan.");
    } finally {
      await sleep(700);
      hideLoading();
    }
  };

  const createOrderInitialOrder = async (flag, FeeSelected) => {
    if (!StudentID) {
      alert("Student ID missing. Please verify email again.");
      return;
    }

    if (!FeeSelected || FeeSelected < 0) {
      alert("Invalid payment amount.");
      return;
    }

    setPaymentOrderGenerated(true);
    showLoading("🔄 Processing your transaction... Just a moment!");

    try {
      let requestBody = {
        student_id: StudentID,
      };

      if (flag === "enrollment_fee") {
        requestBody.payment_context = "REGISTRATION";
      } else if (flag === "One Time Payment") {
        requestBody.payment_context = "TRAINING_ONE_TIME";
        requestBody.plan_type = "ONE_TIME";

        if (couponCode.trim()) {
          requestBody.coupon_code = couponCode.trim().toUpperCase();
        }
      } else if (flag === "Installment Payment") {
        requestBody.payment_context = "TRAINING_INSTALLMENT";
        requestBody.plan_type = "INSTALLMENT";
        requestBody.installment_numbers =
          selectedInstallmentNumbers.length > 0 ? selectedInstallmentNumbers : [1];

        if (couponCode.trim()) {
          requestBody.coupon_code = couponCode.trim().toUpperCase();
        }
      } else {
        alert("Invalid payment type.");
        setPaymentOrderGenerated(false);
        return;
      }

      const response = await fetch(`${API_BASE_URL}/payment/create-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (!response.ok || !data.order_id) {
        alert(data.detail || "Failed to create order.");
        setPaymentOrderGenerated(false);
        return;
      }



      await sleep(700);
      hideLoading();

      const options = {
        key: data.key_id,
        amount: Math.round(Number(data.total_amount) * 100),
        currency: data.currency || "INR",
        name: "StudyAIPlacement",
        description:
          flag === "Installment Payment"
            ? "Technology Learning Fee - Installment"
            : flag === "One Time Payment"
              ? "Technology Learning Fee - One Time"
              : "Registration Fee",
        order_id: data.order_id,

        handler: async (response) => {
          try {
            showLoading("🧠 Verifying your payment...");

            const verifyResponse = await fetch(`${API_BASE_URL}/payment/verify`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                razorpay_order_id: String(response.razorpay_order_id),
                razorpay_payment_id: String(response.razorpay_payment_id),
                razorpay_signature: String(response.razorpay_signature),
              }),
            });

            const verifyData = await verifyResponse.json();

            if (!verifyResponse.ok) {
              alert(verifyData.detail || "Payment verification failed.");
              setPaymentOrderGenerated(false);
              return;
            }

            if (flag === "One Time Payment" || flag === "Installment Payment") {
              window.__ALLOW_PAYMENT_SUCCESS_REDIRECT = true;

              flushSync(() => {
                setPaymentOrderGenerated(false);

                setshowscreen_1(false);
                setshowscreen_2(false);
                setshowscreen_3(false);
                setshowscreen_4(false);

                setShowOtpModal(false);
                setBothPaymentshowOtpModal(false);

                setShowSuccessScreen(true);

                setSuccessMessage(
                  <>
                    <p>🎉 Congratulations! Your payment has been verified successfully.</p>

                    <p>
                      {flag === "One Time Payment"
                        ? "Your full Technology Learning Fee has been paid."
                        : "Your first installment has been paid successfully."}
                    </p>

                    <p>Welcome to StudyAIPlacement. Your learning journey is now activated.</p>

                    <p>You will be redirected to the main page shortly.</p>
                  </>
                );
              });

              return;
            }

            if (flag === "enrollment_fee") {
              flushSync(() => {
                setPaymentOrderGenerated(false);
                setshowscreen_4(false);
                setshowscreen_1(false);
                setshowscreen_2(true);
                setshowscreen_3(false);
              });

              if (BothScreenNextScreen) {
                window.scrollBy({ top: 310, behavior: "smooth" });
              }

              return;
            }
          } catch (error) {
            console.error("Payment verification error:", error);
            alert("Payment verification failed.");
            setPaymentOrderGenerated(false);
          } finally {
            await sleep(700);
            hideLoading();
            document.body.classList.remove("razorpay-active");
          }
        },

        theme: { color: "#3399cc" },
        display: "fullscreen",

        modal: {
          escape: false,
          backdropclose: false,
          ondismiss: function () {
            document.body.classList.remove("razorpay-active");
            setPaymentOrderGenerated(false);

            if (flag === "One Time Payment" || flag === "Installment Payment") {
              setshowscreen_3(true);
            }

            if (flag === "enrollment_fee") {
              setshowscreen_4(true);
            }
          },
        },
      };

      const rzp = new window.Razorpay(options);
      document.body.classList.add("razorpay-active");
      rzp.open();
    } catch (error) {
      console.error("Error creating order:", error);
      alert("Failed to create order.");
      setPaymentOrderGenerated(false);
    } finally {
      await sleep(700);
      hideLoading();
      document.body.classList.remove("razorpay-active");
    }
  };

  const handleProceed = async () => {
    if (!email) {
      alert("Email is required.");
      return;
    }

    if (!validateEmail(email)) {
      alert("Please enter a valid email address.");
      return;
    }

    try {
      console.log(email);
      showLoading("📌 Checking admission status for the provided email...");

      const response = await fetch(`${API_BASE_URL}/check-payment-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      switch (data.code) {
        case 1005:
          alert(
            "No admission record found for this email. Please start a new admission."
          );
          setShowIncompleteAdmission();
          break;

        case 1001: {
          try {
            const counsellingStatusResponse = await fetch(
              `${API_BASE_URL}/counselling/check-status`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  email: email.trim().toLowerCase(),
                }),
              }
            );

            const counsellingStatusData = await counsellingStatusResponse.json();

            if (counsellingStatusData?.counselling_paid) {
              alert(
                "Your application was found. Please verify your email address to continue securely."
              );
            } else {
              alert(
                "Your application was found. Please verify your email address to continue securely."
              );
            }
          } catch (error) {
            alert("Please verify your email address to continue your application.");
          }

          setshowscreen_1(false);
          setStudentID(
            data.student_id ||
              data.student_unique_id ||
              data.studentId
          );
          await handlesentOTPBothPayment(
            data.student_id ||
              data.student_unique_id ||
              data.studentId,
            email
          );
          break;
        }

        case 1002:
          alert(
            "Your application was found. Please verify your email address to continue securely."
          );
          setshowscreen_1(false);
          setStudentID(
            data.student_id ||
              data.student_unique_id ||
              data.studentId
          );
          await handlesentOTP(
          data.student_id ||
            data.student_unique_id ||
            data.studentId,
          email
        );
          break;

        case 1003:
          alert(
            "Your account is active. Please login with your mobile number and password."
          );

          window.scrollTo({ top: 0, behavior: "smooth" });
          onClose();

          if (typeof window.closeTakeAdmission === "function") {
            window.closeTakeAdmission();
          }
          break;

        case 1004:
          alert("Pending mandatory payment. Please complete the remaining fee.");
          break;

        default:
          alert("Unexpected response. Please try again.");
          break;
      }
    } catch (error) {
      alert("Something went wrong. Please try again.");
    } finally {
      await sleep(700);
      hideLoading();
    }
  };

  const handlesentOTP = async (studentUniqueId, email) => {
    if (studentUniqueId) {
      try {
        showLoading(
          "✅ Please wait while we send a verification OTP to your email. This may take a few seconds."
        );

        const randomcode = generateRandomCode();
        setextraletters(randomcode);

        const url_otpsend = `${API_BASE_URL}/send_mailOTP/${studentUniqueId}?email=${encodeURIComponent(
          email
        )}&code=${randomcode}`;

        const responsesendotp = await fetch(url_otpsend, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });

        const dataotp = await responsesendotp.json();

        if (dataotp.status === "success") {
          console.log("OTP sent successfully");
        }
      } catch (error) {
        console.log("An error occurred while sending OTP");
      } finally {
        setShowOtpModal(true);
        await sleep(700);
        hideLoading();
      }
    }
  };

  const handlesentOTPBothPayment = async (studentUniqueId, email) => {
    if (studentUniqueId) {
      try {
        showLoading(
          "✅ Please wait while we send a verification OTP to your email. This may take a few seconds."
        );

        const randomcode = generateRandomCode();
        setextraletters(randomcode);

        const url_otpsend = `${API_BASE_URL}/send_mailOTP/${studentUniqueId}?email=${encodeURIComponent(
          email
        )}&code=${randomcode}`;

        const responsesendotp = await fetch(url_otpsend, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });

        const dataotp = await responsesendotp.json();

        if (dataotp.status === "success") {
          console.log("OTP sent successfully");
        }
      } catch (error) {
        console.log("An error occurred while sending OTP");
      } finally {
        setBothPaymentshowOtpModal(true);
        await sleep(700);
        hideLoading();
      }
    }
  };

  if (showSuccessScreen) {
    return (
      <div className="I-incomplete-admission">
        <PaymentSuccessScreen customMessage={successMessage} />
      </div>
    );
  }

  return (
    <div className="I-incomplete-admission">
      <h2>Resume Your Admission</h2>

      {newAdmissionStatus && (
        <div className="I-new-admission-status" role="status">
          <span className="I-new-admission-status-label">
            ADMISSION PAYMENT STATUS
          </span>

          <h3>
            {newAdmissionStatus.status === "PAID"
              ? "Your Admission Is Confirmed"
              : newAdmissionStatus.status === "RESUMABLE"
              ? "Your Payment Order Is Ready"
              : newAdmissionStatus.status === "NO_RESERVATION"
              ? "Complete Your Admission"
              : "Payment Verification Required"}
          </h3>

          <p>
            {newAdmissionStatus.status === "PAID"
              ? "Your programme admission payment has been verified."
              : newAdmissionStatus.status === "RESUMABLE"
              ? "We found your original payment order. You may verify it before resuming checkout."
              : newAdmissionStatus.status === "NO_RESERVATION"
              ? "No admission payment order exists. Your programme fee is ₹32,500 including GST, or ₹27,500 with one valid referral."
              : "We are checking your previous payment. Please do not pay again until verification is complete."}
          </p>

          {newAdmissionStatus.status === "RESUMABLE" &&
            resumeAdmissionOrder && (
              <button
                type="button"
                className="I-submit-button"
                onClick={handleResumeAdmissionPayment}
              >
                {newCheckoutEnabled ? "Resume Original Payment" : "Verify Original Payment Order"}
              </button>
            )}

          {newAdmissionStatus.status === "NO_RESERVATION" && (
            <div className="I-admission-fee-card">
              <div className="I-fee-card-header">
                <div>
                  <span className="I-fee-eyebrow">
                    PROGRAMME ADMISSION FEE
                  </span>
                  <h4>Confirm your admission</h4>
                </div>
                <span className="I-gst-badge">GST included</span>
              </div>

              <div className="I-fee-breakdown">
                <div className="I-fee-row">
                  <span>Standard programme fee</span>
                  <strong
                    className={
                      newAdmissionReferralValid
                        ? "I-original-fee I-original-fee-discounted"
                        : "I-original-fee"
                    }
                  >
                    ₹32,500
                  </strong>
                </div>

                {newAdmissionReferralValid && (
                  <div className="I-fee-row I-discount-row">
                    <span>Valid referral benefit</span>
                    <strong>− ₹5,000</strong>
                  </div>
                )}

                <div className="I-fee-divider" />

                <div className="I-payable-row">
                  <div>
                    <span>Total payable now</span>
                    <small>No additional GST will be added</small>
                  </div>
                  <strong>
                    ₹{newAdmissionReferralValid ? "27,500" : "32,500"}
                  </strong>
                </div>
              </div>

              <div
                className={
                  newAdmissionReferralValid
                    ? "I-referral-card I-referral-card-valid"
                    : "I-referral-card"
                }
              >
                <div className="I-referral-title-row">
                  <div>
                    <span className="I-referral-label">
                      OPTIONAL REFERRAL BENEFIT
                    </span>
                    <h5>Save ₹5,000 with a valid referral</h5>
                  </div>
                  <span className="I-referral-saving">₹5,000 OFF</span>
                </div>

                <p>
                  If you have a referral code, enter and validate it below.
                  A referral is optional—you can continue admission without one
                  at the standard fee of ₹32,500.
                </p>

                <div className="I-referral-controls">
                  <input
                    className="I-input I-referral-input"
                    type="text"
                    maxLength={20}
                    value={newAdmissionReferral}
                    onChange={(event) => {
                      setNewAdmissionReferral(
                        event.target.value.toUpperCase()
                      );
                      setNewAdmissionReferralValid(false);
                    }}
                    placeholder="Enter referral code"
                    aria-label="Optional referral code"
                  />

                  <button
                    type="button"
                    className="I-referral-validate-button"
                    disabled={
                      newAdmissionBusy ||
                      !newAdmissionReferral.trim()
                    }
                    onClick={validateNewAdmissionReferral}
                  >
                    {newAdmissionBusy ? "Checking..." : "Apply Code"}
                  </button>

                  {newAdmissionReferral && (
                    <button
                      type="button"
                      className="I-referral-clear-button"
                      disabled={newAdmissionBusy}
                      onClick={() => {
                        setNewAdmissionReferral("");
                        setNewAdmissionReferralValid(false);
                      }}
                    >
                      Clear
                    </button>
                  )}
                </div>

                {newAdmissionReferralValid ? (
                  <div className="I-referral-message I-referral-success">
                    Referral verified. Your ₹5,000 discount has been applied.
                  </div>
                ) : (
                  <div className="I-referral-message">
                    No referral? Simply continue with the standard fee.
                  </div>
                )}
              </div>

              <button
                type="button"
                disabled={newAdmissionBusy}
                className="I-secure-payment-button"
                onClick={startNewAdmissionPayment}
              >
                <span>
                  {newAdmissionBusy
                    ? "Preparing secure checkout..."
                    : `Pay ₹${
                        newAdmissionReferralValid
                          ? "27,500"
                          : "32,500"
                      } securely`}
                </span>
                {!newAdmissionBusy && <span aria-hidden="true">→</span>}
              </button>

              <div className="I-payment-trust-note">
                Secure payment powered by Razorpay • GST included • Payment
                verification happens automatically
              </div>
            </div>
          )}

          {newAdmissionStatus.status !== "PAID" && (
            <p className="I-new-admission-help">
              Admission support can help you complete the remaining steps.
            </p>
          )}
        </div>
      )}

      {showscreen_1 && (
        <>
          <p>Enter your registered email to continue the admission process.</p>

          <div className="I-input-container">
            <input
              type="email"
              className="I-input"
              placeholder="Enter your registered email"
              value={email}
              onChange={handleEmailChange}
              maxLength={50}
            />

            <button className="I-submit-button" onClick={handleProceed}>
              Check Email
            </button>
          </div>

          <div className="I-warning-box">
            <p>
              <strong>Note:</strong> Please enter the email ID you used during
              registration and click <strong>Check Email</strong> to verify. If
              the system shows <strong>Email not found</strong>, it means your
              previous registration was not completed. In that case, you can
              start fresh by clicking <strong>New Admission</strong> and
              completing the process again.
            </p>
          </div>
        </>
      )}

      {showOtpModal && (
        <OTPModal
          student_id={StudentID}
          email={email}
          extraletters={extraletters}
          showEditMail={false}
          onClose={async (sessionToken) => {
            setShowOtpModal(false);
            await checkNewAdmissionPaymentAfterOtp(sessionToken);
          }}
        />
      )}

      {BothPaymentshowOtpModal && (
        <OTPModal
          student_id={StudentID}
          email={email}
          extraletters={extraletters}
          showEditMail={false}
          onClose={async (sessionToken) => {
            setBothPaymentshowOtpModal(false);
            await checkNewAdmissionPaymentAfterOtp(sessionToken);
          }}
        />
      )}

      {showIncompleteCounselling &&
        !PaymentOrderGenerated &&
        !showSuccessScreen && (
          <>
            <div className="payment-overlay"></div>

            <div className="admission-counselling-container">
              <div className="admission-counselling-header">
                <span>FIRST STEP OF YOUR JOURNEY</span>

                <h2>Book Personal Career Counselling</h2>

                <p>
                  Before your admission continues, Akshay Sir personally understands
                  your skills, goals, confusion, discipline, life ambition and career
                  direction.
                </p>
              </div>

              <div className="admission-counselling-grid">
                <div className="admission-counselling-card">
                  <div className="admission-counselling-card-title">
                    <span>01</span>

                    <div>
                      <h3>Select counselling slot</h3>
                      <p>Choose your preferred date and time.</p>
                    </div>
                  </div>

                  {counsellingSlotsLoading ? (
                    <div className="admission-counselling-loading">
                      Loading available slots...
                    </div>
                  ) : counsellingCalendarDays.length === 0 ? (
                    <div className="admission-counselling-empty">
                      No counselling slots available right now. Please try again later.
                    </div>
                  ) : (
                    <>
                      <div className="admission-date-scroll">
                        {counsellingCalendarDays.map((day) => (
                          <button
                            type="button"
                            key={day.dateKey}
                            className={`admission-date-pill ${counsellingSelectedDate === day.dateKey ? "active" : ""
                              }`}
                            onClick={() => {
                              setCounsellingSelectedDate(day.dateKey);
                              setCounsellingSelectedSlot(null);
                            }}
                          >
                            <b>{day.dayName || new Date(day.dateKey).toLocaleDateString("en-IN", {
                              weekday: "short",
                            })}</b>

                            <span>
                              {day.displayDate ||
                                new Date(day.dateKey).toLocaleDateString("en-IN", {
                                  day: "2-digit",
                                  month: "short",
                                })}
                            </span>

                            <small>{day.available_count || 0} slots</small>
                          </button>
                        ))}
                      </div>

                      <div className="admission-slot-grid">
                        {(activeCounsellingDay?.slots || []).map((slot) => (
                          <button
                            type="button"
                            key={slot.time}

                            disabled={slot.available !== true}
                            className={`admission-slot-pill ${counsellingSelectedSlot?.time === slot.time
                              ? "active"
                              : ""
                              }`}
                            onClick={() => {
                              if (slot.available === true) {
                                setCounsellingSelectedSlot(slot);
                              }
                            }}
                          >
                            <span>{slot.time}</span>
                            <small>{slot.available === true ? "Available" : "Booked"}</small>
                          </button>
                        ))}
                      </div>
                    </>
                  )}
                </div>

                <div className="admission-counselling-card">
                  <div className="admission-counselling-card-title">
                    <span>02</span>

                    <div>
                      <h3>Confirm counselling</h3>
                      <p>
                        Your registered admission details will be used automatically.
                      </p>
                    </div>
                  </div>

                  <div className="admission-counselling-note">
                    <b>Registered Email</b>
                    <p>{email}</p>
                  </div>

                  <label className="admission-counselling-field">
                    What do you want to discuss?
                    <small> Optional</small>

                    <textarea
                      value={counsellingGoal}
                      onChange={(e) =>
                        setCounsellingGoal(e.target.value.slice(0, 300))
                      }
                      placeholder="Example: I want to understand my career roadmap, placement plan, discipline, and technical preparation."
                      maxLength={300}
                    />
                  </label>

                  <div className="admission-counselling-fee-box">
                    <div>
                      <span>Counselling Fee</span>
                      <b>₹{registrationFee}</b>
                    </div>

                    <div>
                      <span>GST ({gstPercent}%)</span>
                      <b>₹{((registrationFee * gstPercent) / 100).toFixed(2)}</b>
                    </div>

                    <div className="total">
                      <span>Total Payable</span>
                      <b>₹{(registrationFee + (registrationFee * gstPercent) / 100).toFixed(2)}</b>
                    </div>
                  </div>

                  <button
                    className="admission-counselling-pay-btn"
                    type="button"
                    disabled={counsellingPaymentStarted}
                    onClick={handleIncompleteCounsellingPayment}
                  >
                    {counsellingPaymentStarted
                      ? "Starting Payment..."
                      : `Pay ₹${(
                        registrationFee +
                        (registrationFee * gstPercent) / 100
                      ).toFixed(2)} & Confirm Counselling`}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}

      {showCouponSuccessModal && couponData && (
        <div className="coupon-success-overlay">
          <div className="coupon-success-modal">
            <button
              type="button"
              className="coupon-success-close"
              onClick={() => setShowCouponSuccessModal(false)}
            >
              ×
            </button>

            <span>COUPON APPLIED SUCCESSFULLY</span>

            <h2>Congratulations!</h2>

            <p>
              You received a discount of{" "}
              <b>₹{Number(couponData.student_discount_amount || 0).toLocaleString("en-IN")}</b>{" "}
              using coupon <b>{couponData.coupon_code}</b>.
            </p>

            <div className="coupon-success-info">
              <div>
                <strong>One-Time Payment</strong>
                <p>
                  Discount is applied immediately. You pay the discounted Technology
                  Learning Fee now.
                </p>
              </div>

              <div>
                <strong>Installment Plan</strong>
                <p>
                  First installment remains same. Your discount is adjusted in the
                  final installments, especially the last month.
                </p>
              </div>
            </div>

            <button
              type="button"
              className="coupon-success-action"
              onClick={() => setShowCouponSuccessModal(false)}
            >
              Continue to Payment
            </button>
          </div>
        </div>
      )}

      {showscreen_2 && !PaymentOrderGenerated && !showSuccessScreen && (
        <>
          <div className="payment-overlay"></div>
          <div className="payment-options-scroll-shell">
            <div className="coupon-box">
              {!couponApplied ? (
                <>
                  <h3>Have a referral coupon?</h3>
                  <p>
                    Apply coupon and get{" "}
                    <b>₹{Number(paymentConfig?.coupon_discount || 5000).toLocaleString("en-IN")}</b>{" "}
                    discount on Technology Learning Fee.
                  </p>

                  <div className="coupon-input-row">
                    <input
                      type="text"
                      value={couponCode}
                      placeholder="ENTER COUPON CODE"
                      maxLength={20}
                      onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                    />

                    <button
                      type="button"
                      disabled={couponApplying}
                      onClick={handleApplyCoupon}
                    >
                      {couponApplying ? "Checking..." : "Apply"}
                    </button>
                  </div>
                </>
              ) : (
                <div className="coupon-applied-box">
                  <span>COUPON APPLIED</span>
                  <h3>Congratulations! You saved ₹{couponDiscountAmount.toLocaleString("en-IN")}</h3>
                  <p>
                    Coupon <b>{couponCode}</b> is active. This discount is applied only on
                    Technology Learning Fee.
                  </p>

                  <button
                    type="button"
                    onClick={() => {
                      setCouponApplied(false);
                      setCouponData(null);
                      setCouponCode("");
                    }}
                  >
                    Remove Coupon
                  </button>
                </div>
              )}
            </div>

            <div className="pricing-container program-fee-options">
              <div className="O-payment-card">
                <h2 className="O-payment-title">
                  One-Time Technology Learning Fee
                </h2>

                <div className="O-payment-details">
                  <div className="O-detail-row">
                    <span className="O-label">Base Fee</span>

                    <span className="O-value">
                      {couponApplied ? (
                        <>
                          <del>₹{ONE_TIME_PAYMENT.toLocaleString("en-IN")}</del>{" "}
                          <b>₹{discountedOneTimeBase.toLocaleString("en-IN")}</b>
                        </>
                      ) : (
                        <>₹{ONE_TIME_PAYMENT.toLocaleString("en-IN")}</>
                      )}
                    </span>
                  </div>

                  {couponApplied && (
                    <div className="O-detail-row discount-row">
                      <span className="O-label">Coupon Discount</span>
                      <span className="O-value">
                        -₹{couponDiscountAmount.toLocaleString("en-IN")}
                      </span>
                    </div>
                  )}

                  <div className="O-detail-row">
                    <span className="O-label">
                      GST ({gstPercent}%){" "}
                      <span className="gov-india">(Government of India 🇮🇳)</span>
                    </span>
                    <span className="O-value">
                      ₹{(couponApplied ? discountedOneTimeGst : gstAmountTotal).toLocaleString("en-IN")}
                    </span>
                  </div>

                  <div className="O-detail-row O-total">
                    <span className="O-label">Total Payable</span>

                    <span className="O-value final-discount-price">
                      {couponApplied ? (
                        <>
                          <del>₹{totalPayable.toLocaleString("en-IN")}</del>{" "}
                          <b>₹{discountedOneTimeTotal.toLocaleString("en-IN")}</b>
                        </>
                      ) : (
                        <>₹{totalPayable.toLocaleString("en-IN")}</>
                      )}
                    </span>
                  </div>
                </div>

                <button
                  className="O-pay-button"
                  onClick={() => prepareTrainingPayment("ONE_TIME")}
                >
                  Pay One-Time Fee
                </button>
              </div>


              <div className="O-payment-card installment-card">
                <h2 className="O-payment-title">Installment Plan</h2>

                <button
                  type="button"
                  className="view-schedule-btn"
                  onClick={() => setShowInstallmentSchedule(true)}
                >
                  View Full Installment Schedule
                </button>

                <div className="plan-summary-box">
                  <div className="plan-summary-row">
                    <span>One-Time Fee</span>
                    <b>₹{ONE_TIME_PAYMENT.toLocaleString("en-IN")}</b>
                  </div>

                  <div className="plan-summary-row">
                    <span>Installment Total Fee</span>
                    <b>
                      {couponApplied ? (
                        <>
                          <del>₹{installmentTotalFee.toLocaleString("en-IN")}</del>{" "}
                          ₹{discountedInstallmentTotalFee.toLocaleString("en-IN")}
                        </>
                      ) : (
                        <>₹{installmentTotalFee.toLocaleString("en-IN")}</>
                      )}
                    </b>
                  </div>

                  {couponApplied && (
                    <>
                      <div className="plan-summary-row">
                        <span>Coupon Discount</span>
                        <b className="discount-text">
                          -₹{couponDiscountAmount.toLocaleString("en-IN")}
                        </b>
                      </div>

                      <div className="plan-summary-row coupon-note-row">
                        <span>Discount Adjustment</span>
                        <b>Applied in final installments</b>
                      </div>
                    </>
                  )}

                  <div className="plan-summary-row warning">
                    <span>Extra For Installment Flexibility</span>
                    <b>₹{installmentExtraFee.toLocaleString("en-IN")}</b>
                  </div>

                  {couponApplied && (
                    <div className="plan-summary-row final-plan-total-row">
                      <span>Total Plan Payable With GST</span>
                      <b>
                        <del>₹{installmentGrandTotal.toLocaleString("en-IN")}</del>{" "}
                        ₹{discountedInstallmentGrandTotal.toLocaleString("en-IN")}
                      </b>
                    </div>
                  )}

                  <div className="plan-summary-row">
                    <span>Pay Now</span>
                    <b>₹{installmentTotalPayable.toLocaleString("en-IN")}</b>
                  </div>
                </div>

                <button
                  className="O-pay-button"
                  onClick={() => prepareTrainingPayment("INSTALLMENT")}
                >
                  Pay First Installment
                </button>
              </div>
            </div></div>
        </>
      )}

      {showscreen_3 && !showSuccessScreen && !PaymentOrderGenerated && (
        <>
          <div className="payment-overlay"></div>

          <div className="payment-container">
            <h2 className="payment-title">
              {PayOutHeading === "Installment Payment"
                ? "AI Upskill Fee Payment - Installment Payment"
                : "AI Upskill Fee Payment - One Time Payment"}
            </h2>

            <div className="amount-summary">
              <p>
                <span className="label">
                  {PayOutHeading === "Installment Payment"
                    ? "First Installment:"
                    : "Technology Learning Fee:"}
                </span>{" "}
                ₹{fee.toFixed(2)}
              </p>

              <p className="gst-info">
                <span className="label">GST ({gstPercent}%)</span>
                <span className="gov-india"> (Government of India 🇮🇳) </span>:
                ₹{gstAmount.toFixed(2)}
              </p>

              <p>
                <span className="label total-label">Total Payable:</span> ₹
                {totalAmount.toFixed(2)}
              </p>
            </div>

            <button
              className="pay-button"
              onClick={() => createOrderInitialOrder(PayOutHeading, fee)}
            >
              Pay ₹{totalAmount.toFixed(2)}
            </button>
          </div>
        </>
      )}

      {showscreen_4 && !showSuccessScreen && !PaymentOrderGenerated && (
        <>
          <div className="payment-overlay"></div>

          <div className="payment-container">
            <h2 className="payment-title">Enrollment Fee Payment</h2>

            <div className="amount-summary">
              <p>
                <span className="label">Enrollment Fee:</span> ₹{fee.toFixed(2)}
              </p>

              <p className="gst-info">
                <span className="label">GST ({gstPercent}%) </span>
                <span className="gov-india"> (Government of India 🇮🇳) </span>:
                ₹{gstAmount.toFixed(2)}
              </p>

              <p>
                <span className="label total-label">Total Payable:</span> ₹
                {totalAmount.toFixed(2)}
              </p>
            </div>

            <button
              className="pay-button"
              onClick={() => createOrderInitialOrder("enrollment_fee", fee)}
            >
              Pay ₹{totalAmount.toFixed(2)}
            </button>
          </div>
        </>
      )}


      {showInstallmentSchedule && (
        <div className="installment-popup-overlay">
          <div className="installment-popup-card">
            <button
              type="button"
              className="installment-popup-close"
              onClick={() => setShowInstallmentSchedule(false)}
            >
              Close
            </button>

            <h2>Installment Schedule</h2>

            <p className="installment-popup-subtitle">
              Your installment plan is divided across 7 months.
            </p>

            <div className="installment-popup-list">
              {installmentSchedule.map((item) => {
                let discountForThisInstallment = 0;

                if (couponApplied) {
                  if (item.installment_number === 7) {
                    discountForThisInstallment = Math.min(item.amount_inr, couponDiscountAmount);
                  }

                  if (item.installment_number === 6 && couponDiscountAmount > 4100) {
                    discountForThisInstallment = couponDiscountAmount - 4100;
                  }
                }

                const finalBaseAmount = Math.max(item.amount_inr - discountForThisInstallment, 0);
                const finalGstAmount = getGstAmount(finalBaseAmount);
                const finalTotalAmount = finalBaseAmount + finalGstAmount;

                return (
                  <div
                    className="installment-popup-row gst-row"
                    key={item.installment_number}
                  >
                    <span>{item.installment_number} Installment</span>

                    <small>Month {item.month_number}</small>

                    <div className="installment-amount-breakup">
                      {discountForThisInstallment > 0 ? (
                        <>
                          <b>
                            <del>₹{item.amount_inr.toLocaleString("en-IN")}</del>{" "}
                            ₹{finalBaseAmount.toLocaleString("en-IN")}
                          </b>

                          <em>
                            Discount ₹{discountForThisInstallment.toLocaleString("en-IN")}
                          </em>

                          <strong>
                            Total ₹{finalTotalAmount.toLocaleString("en-IN")}
                          </strong>
                        </>
                      ) : (
                        <>
                          <b>₹{item.amount_inr.toLocaleString("en-IN")}</b>
                          <em>
                            GST ₹{getGstAmount(item.amount_inr).toLocaleString("en-IN")}
                          </em>
                          <strong>
                            Total ₹{getTotalWithGst(item.amount_inr).toLocaleString("en-IN")}
                          </strong>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="installment-popup-total installment-grand-total">
  <span>Total Base Fee</span>

  <b>
    {couponApplied ? (
      <>
        <del>₹{installmentBaseTotal.toLocaleString("en-IN")}</del>{" "}
        ₹{discountedInstallmentTotalFee.toLocaleString("en-IN")}
      </>
    ) : (
      <>₹{installmentBaseTotal.toLocaleString("en-IN")}</>
    )}
  </b>
</div>

            <div className="installment-popup-total installment-grand-total">
  <span>Total GST</span>

  <b>
    {couponApplied ? (
      <>
        <del>₹{installmentGstTotal.toLocaleString("en-IN")}</del>{" "}
        ₹{discountedInstallmentTotalGst.toLocaleString("en-IN")}
      </>
    ) : (
      <>₹{installmentGstTotal.toLocaleString("en-IN")}</>
    )}
  </b>
</div>

            <div className="installment-popup-total installment-grand-total final">
              <span>Total Payable With GST</span>

              <b className="final-discount-price">
                {couponApplied ? (
                  <>
                    <del>₹{installmentGrandTotal.toLocaleString("en-IN")}</del>{" "}
                    ₹{discountedInstallmentGrandTotal.toLocaleString("en-IN")}
                  </>
                ) : (
                  <>₹{installmentGrandTotal.toLocaleString("en-IN")}</>
                )}
              </b>
            </div>

            <button
              className="O-pay-button"
              onClick={() => prepareTrainingPayment("INSTALLMENT")}
            >
              Pay First Installment
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default IncompleteAdmission;